export async function parseResumeWithAPI(rawText) {
  const prompt = `You are a resume parser. Extract the following structured JSON from the pasted resume text.
Return ONLY valid JSON, no preamble, no markdown fences, no commentary.

Schema:
{
  "name": "string",
  "contact": {
    "phone": "string",
    "email": "string",
    "location": "string (City, ST)",
    "linkedin": "string (URL or handle)",
    "website": "string"
  },
  "summary": {
    "tagline": "string (one short italic line, e.g. 'Multi-faceted retail executive with expertise in:')",
    "bullets": ["string"],
    "skills": ["string"]
  },
  "experience": [{
    "title": "string",
    "company": "string",
    "location": "string",
    "start": "string (e.g. 'Jan 2022')",
    "end": "string ('Present' or end date)",
    "summary": "string (optional paragraph, may be empty)",
    "bullets": ["string"]
  }],
  "education": [{
    "degree": "string",
    "school": "string",
    "location": "string",
    "date": "string",
    "honors": "string (optional)"
  }],
  "certifications": [{ "name": "string", "org": "string", "date": "string" }],
  "projects": [{ "name": "string", "description": "string", "bullets": ["string"] }],
  "awards": ["string"]
}

If a field is missing, use empty string or empty array. Do not invent content.

Resume text:
${rawText}`;

  const response = await fetch("https://api.anthropic.com/v1/messages", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-20250514",
      max_tokens: 2000,
      messages: [{ role: "user", content: prompt }],
    }),
  });

  if (!response.ok) {
    throw new Error(`API request failed: ${response.status}`);
  }

  const result = await response.json();
  const text = result.content
    .filter(b => b.type === 'text')
    .map(b => b.text)
    .join('\n');

  const cleaned = text.replace(/```json\s*/gi, '').replace(/```\s*$/g, '').trim();
  const parsed = JSON.parse(cleaned);

  return {
    name: parsed.name || "",
    contact: {
      phone: parsed.contact?.phone || "",
      email: parsed.contact?.email || "",
      location: parsed.contact?.location || "",
      linkedin: parsed.contact?.linkedin || "",
      website: parsed.contact?.website || "",
    },
    summary: {
      tagline: parsed.summary?.tagline || "",
      bullets: parsed.summary?.bullets || [],
      skills: parsed.summary?.skills || [],
    },
    experience: (parsed.experience || []).map(e => ({
      title: e.title || "",
      company: e.company || "",
      location: e.location || "",
      start: e.start || "",
      end: e.end || "",
      summary: e.summary || "",
      bullets: e.bullets || [],
    })),
    education: (parsed.education || []).map(e => ({
      degree: e.degree || "",
      school: e.school || "",
      location: e.location || "",
      date: e.date || "",
      honors: e.honors || "",
    })),
    certifications: (parsed.certifications || []).map(c => ({
      name: c.name || "",
      org: c.org || "",
      date: c.date || "",
    })),
    projects: (parsed.projects || []).map(p => ({
      name: p.name || "",
      description: p.description || "",
      bullets: p.bullets || [],
    })),
    awards: parsed.awards || [],
  };
}
